import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const cn = (...classes) => classes.filter(Boolean).join(" ");

export function confidenceClass(c) {
  if (c == null) return "conf-mid";
  if (c >= 0.9) return "conf-high";
  if (c >= 0.7) return "conf-mid";
  return "conf-low";
}

export function confidenceLabel(c) {
  if (c == null) return "—";
  return `${Math.round(c * 100)}%`;
}
